import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../adl-gen/common';
import { DbKey, WithDbId } from '../../../adl-gen/common/db';
import { Report } from '../../../adl-gen/totalinteraction/futurefit/db';
// import { withI18n, WithI18nProps } from "../../../internationalization/i18n-hoc";
import { Loader, MaybeLoading } from '../../../loader/loader';
import { Route } from '../../../routing/app-routes';
import { LoggedIn, LoggedInSuper } from '../../../stores/identity-store';
import { PageLayoutFn } from '../../common/page-layout/page-layout';
import { ReportTile, TileAccordions } from '../../components/tile-accordions/tile-accordions';

interface ReportsPortalScreenProps {
  //} extends WithI18nProps {
  pageLayout: PageLayoutFn;

  reports: MaybeLoading<Paginated<WithDbId<Report>>>;

  identity: LoggedIn | LoggedInSuper;

  navigateTo(route: Route): void;

  onClickReport(reportId: DbKey<Report>): Promise<void>; //, clientName: string,  clientId: DbKey<AppClient>): Promise<void>;

  walkThroughFn?(page: string): void;

  /** Whether to render as in progress mode - exposed for storybook testing */
  alwaysInProgress?: boolean;
}

@observer
export class ReportsPortalScreen extends React.Component<ReportsPortalScreenProps> {
  renderReports(reports: WithDbId<Report>[]) {
    return (
      <TileAccordions
        kind={'report'}
        reportTiles={reports.map(report => this.reportToReportTile(report, this.props.onClickReport))}
      />
    );
  }

  reportToReportTile(
    reportWithId: WithDbId<Report>,
    onClickReport: ReportsPortalScreenProps['onClickReport']
  ): ReportTile {
    const report = reportWithId.value;
    // const { appClientId } = this.props.identity.appUserWithDbId.value;
    // const { name } = this.props.identity.appClient;
    // const subtitle = (userQuiz.status.completedAt === null) ? undefined : moment(userQuiz.status.completedAt).format("DD/MM/YYYY h:mm a");
    return {
      // TODO Internationalization
      title: report.title,
      // subtitle: report.description,
      imageUrl: report.imageUrl,
      id: reportWithId.id,
      onClick: () => onClickReport(reportWithId.id), //, name, appClientId),
      enabled: true,
      tag: 'TODO CSV'
    };
  }

  renderLoaded = observer((reports: Paginated<WithDbId<Report>>) => {
    if (this.props.walkThroughFn) {
      this.props.walkThroughFn('');
    }
    return this.renderReports(reports.items);
  });

  render() {
    return (
      <this.props.pageLayout>
        <Loader state={this.props.reports} LoadedComponent={this.renderLoaded} />
      </this.props.pageLayout>
    );
  }
}

// export const ReportsScreen = withI18n(ReportsScreen0);



// WEBPACK FOOTER //
// ./src/ui/screens/reports-portal/reports-portal.tsx